import Navbar from "../../components/navbar/Navbar";
import "./PrivacyPolicy.css";

function PrivacyPolicy() {
  return (
    <div className="privacyPolicy-page">
      <Navbar />
      <h1>No data is collected or processed</h1>
    </div>
  );
}

export default PrivacyPolicy;
